import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EventsService } from 'src/app/services/events.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-events-page',
  templateUrl: './events-page.component.html',
  styleUrls: ['./events-page.component.scss'],
})
export class EventsPageComponent implements OnInit {
  loading: any = true;
  type: any = 'todos';
  constructor(
    private eventsService: EventsService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  lat!: number;
  lng!: number;

  dateFilter: any = new Date();
  textFilter: any = '';

  clickSearch: any = false;
  today: any = new Date();
  date: any;

  events = [];

  ngOnInit(): void {
    let month = this.dateFilter.getUTCMonth() + 1;
    let day = this.dateFilter.getUTCDate();
    const year = this.dateFilter.getUTCFullYear();

    month = month.toString().length === 2 ? month : '0' + month;
    day = day.toString().length === 2 ? day : '0' + day;

    this.date = year + '-' + month + '-' + day;

    let element = document.querySelector('.tittle-navbar') as HTMLElement;
    element.innerHTML = 'Eventos';

    this.route.params.subscribe(async (params) => {
      this.loading = true;
      this.type = params['type'] || 'todos';
      this.textFilter = params['textFilter'] || '';

      this.searchDate();
    });
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position: any) => {
          if (position) {
            this.lat = position.coords.latitude;
            this.lng = position.coords.longitude;
          }
        },
        (error: any) => console.log(error)
      );
    } else {
      alert('Geolocation is not supported by this browser.');
    }
  }

  async changeFilters() {
    let month = this.dateFilter.getUTCMonth() + 1;
    let day = this.dateFilter.getUTCDate();
    const year = this.dateFilter.getUTCFullYear();

    month = month.toString().length === 2 ? month : '0' + month;
    day = day.toString().length === 2 ? day : '0' + day;

    this.date = year + '-' + month + '-' + day;

    this.router.navigate([
      'events',
      {
        type: this.type,
        date: this.date,
        textFilter: this.textFilter,
      },
    ]);
  }

  clearTextFiler() {
    this.textFilter = '';
    this.clickSearch = false;
    this.changeFilters();
  }

  buttonSearchText() {
    this.clickSearch = true;

    if (this.textFilter.length >= 3) {
      this.changeFilters();
    } else {
      Swal.fire({
        position: 'center',
        icon: 'info',
        title: 'No se puede realizar la busqueda',
        text: 'Al buscar tiene que contener minimo 3 letras.',
        showConfirmButton: true,
        confirmButtonColor: 'black',
        timer: 2000,
      });
      this.clearTextFiler();
    }
  }

  activateButtonSearch() {
    this.clickSearch = false;
  }
  // searchToday() {
  //   this.dateFilter = new Date();
  //   this.searchDate();
  // }

  async searchDate() {
    this.loading = true;
    this.events = [];

    this.eventsService
      .getEvents(this.date, this.type, this.textFilter)
      .subscribe((data) => {
        if (data.result) {
          this.events = data.result;

          // this.events = [
          //   ...this.events,
          //   ...this.events,
          //   ...this.events,
          //   ...this.events,
          //   ...this.events,
          //   ...this.events,
          // ];
        } else {
        }
        this.loading = false;
      });
  }
}
